import { SETUP_2FA, DISABLE_2FA, VALIDATE_2FA } from "actions/ActionTypes";
import { postApi } from "actions/SendActions";

export const setup2FA = (token, onActivate, onError, t) =>
  postApi({
    endpoint: "/api/user/v3/admin/2fa/setup",
    type: SETUP_2FA,
    token,
    callback: (resp) => {
      onActivate(resp);
    },
    callbackError: () => {
      onError(t("editor-errors:2FA_failed"));
    },
  });

export const confirm2FA = (data, token, onConfirm, onError, t) =>
  postApi({
    endpoint: "/api/user/v3/admin/2fa/validate",
    type: VALIDATE_2FA,
    token,
    data,
    callback: (resp) => {
      onConfirm(resp);
    },
    callbackError: () => {
      onError(t("editor-errors:2FA_failed"));
    },
  });

export const disable2FA = (data, token, onDisable, onError, t) =>
  postApi({
    endpoint: "/api/user/v3/admin/2fa/disable",
    type: DISABLE_2FA,
    token,
    data,
    callback: (resp) => {
      onDisable(resp);
    },
    callbackError: () => {
      onError(t("editor-errors:2FA_deactivation_failed"));
    },
  });
